import { render, staticRenderFns } from "./page_home.vue?vue&type=template&id=d27f3a96&scoped=true"
import script from "./page_home.vue?vue&type=script&lang=js"
export * from "./page_home.vue?vue&type=script&lang=js"
import style0 from "./page_home.vue?vue&type=style&index=0&id=d27f3a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27f3a96",
  null
  
)

export default component.exports